export const INSTALLERS_DEFAULT_FILTERS = {
  _pagina: '1',
  _num_x_pagina: '10',
}

export const INSTALLERS_FILTERS = [
  {
    name: 'razon_social',
    filterType: 'basic-input',
    label: 'pages.prescriptor.installers.filter.razon_social',
  },
  {
    name: 'activo',
    filterType: 'switch',
    label: 'pages.prescriptor.installers.filter.activo',
  },
  {
    name: 'empresa_ca_id',
    filterType: 'input',
    label: 'pages.prescriptor.installers.filter.empresa_ca_id',
    comboId: 'user_empresas_ca',
  },
]
